import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { MembreComite } from "../../core/model/membre-comite";
import { MembreComiteService } from "../../core/service/membre-comite.service";

@Component({
  selector: "app-edit-membre-comite",
  templateUrl: "./edit-membre-comite.component.html",
  styleUrls: ["./edit-membre-comite.component.scss"],
})
export class EditMembreComiteComponent implements OnInit {
  @Input()
  set membreComite(value: MembreComite) {
    if (value) {
      this._membreComite = { ...value };
      this.cdr.detectChanges();
    }
  }
  get membreComite(): MembreComite {
    return this._membreComite;
  }

  private _membreComite: MembreComite;

  form2: FormGroup;
  pressButton: Boolean = false;
  loading = false;

  constructor(
    private _membreComiteService: MembreComiteService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      nom: [null, Validators.compose([Validators.required])],
      prenom: [null, Validators.compose([Validators.required])],
      civilite: [null, Validators.compose([Validators.required])],
      entreprise: [null, Validators.compose([Validators.required])],
      poste: [null, Validators.compose([Validators.required])],
      businessEmail: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this._membreComiteService
      .putMembreComite(this.membreComite)
      .pipe(first())
      .subscribe(
        () => {
          this.pressButton = false;
          this.activeModal.close(this.membreComite);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
